import { Link } from 'react-router-dom';
import { hotAnime } from '@/mocks/homeData';

export default function HotRecommendSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="text-primary-500 text-xs md:text-sm font-medium tracking-wide uppercase mb-1">
              HOT RECOMMEND
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm mt-1">
              全网最热动漫，大家都在看
            </p>
          </div>
          <Link
            to="/category/reboot"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Anime grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {hotAnime.map((anime, idx) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="group cursor-pointer"
            >
              {/* Cover image */}
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  className="w-full h-full object-cover transition-transform duration-400 group-hover:scale-105"
                  loading={idx < 4 ? 'eager' : 'lazy'}
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs font-medium">点击查看详情</span>
                </div>
                {/* Rating badge */}
                <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-black/60 backdrop-blur-sm text-accent-500 text-xs font-bold">
                  {anime.rating}
                </div>
                {/* Episode badge */}
                <div className="absolute top-2 left-2 px-2 py-1 rounded-md bg-primary-500/90 text-white text-xs font-medium">
                  {anime.episode.includes('更新至') ? '连载' : '完结'}
                </div>
              </div>

              {/* Info */}
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                {anime.title}
              </h3>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>{anime.episode}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line text-[10px]"></i>
                  {anime.views}
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile view all */}
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/reboot"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 text-sm font-medium text-primary-500 border border-primary-300 rounded-full hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部热门动漫 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}